import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'src/app/models/MenuItem';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CONSTANTES } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public fileUrl: any;
  public pdfarray: string;
  public mensajesUser: string[];
  public user: string;
  public role: string;
  public mensajesNoLeidos: string;
  public articulosGuardados: string;
  public activeUser: string;
  public forcedChangePassword: string;
  public navImage = CONSTANTES.navBarImage;
  public menuImage = CONSTANTES.menuImage;
  public menuItems: MenuItem[];
  public menuItemCodes: string[] = [];
  
  constructor(private authService: AuthenticationService,
    private router: Router) {
  }
  ngOnInit() {

    jQuery.getScript(CONSTANTES.menu);

    this.user = localStorage.getItem("nid");
    this.role = localStorage.getItem("role");
  }  

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      },
      error => {
        this.router.navigate(['login']);
      }
    );
  }

}
